export const DISPLAY_MODE_REVJET = 'revjet';
export const DISPLAY_MODE_ETCH = 'display rich content';
export const DISPLAY_MODE_SALSIFY = 'salsify';
export const PLA_FEATURE_SWITCH = 'fs-prop:pip-master__product-overview--showSponsoredPla';